// Aviso do teste grátis (faixa no topo do app): só na reta final, não o mês inteiro
export const DIAS_AVISO_TRIAL = 5;

export function diasRestantesTrial(perfil, agora = Date.now()) {
  const fim = perfil?.trialEndsAt?.toDate?.() || (perfil?.trialEndsAt ? new Date(perfil.trialEndsAt) : null);
  return fim ? Math.max(0, Math.ceil((fim - agora) / 86400000)) : null;
}

export function mostrarAvisoTrial(perfil, isento, agora = Date.now()) {
  if (isento || perfil?.plan !== "trial") return false;
  const dias = diasRestantesTrial(perfil, agora);
  return dias !== null && dias > 0 && dias <= DIAS_AVISO_TRIAL;
}
